Namespace 'Models.Parsers'

class Models.Parsers.InstagramUserParser
  parse: (json) ->
    username = json.username || I18n.t('monitoring.rules.fields.unknown')
    name = json.name || username
    profilePictureUrl = json.profile_picture_url
    id = json.id
    new Models.InstagramUser(id, username, name, profilePictureUrl)
